import type {AxiosRequestConfig} from 'axios';
import {
  AuthenticationBody,
  DemoOptAuthenticationBody,
  OptAuthenticationBody,
  OptGenerateBody,
} from './interface';

export class AuthenticationRequestBuilder {
  private readonly authenticationRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/authenticate',
    data: {},
  };

  data(data: AuthenticationBody) {
    this.authenticationRequest.data = data;
    return this;
  }

  build() {
    return this.authenticationRequest;
  }
}

export class OptAuthenticationRequestBuilder {
  private readonly authenticationRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/otp/authenticate',
    data: {},
  };

  data(data: OptAuthenticationBody) {
    this.authenticationRequest.data = data;
    return this;
  }

  build() {
    return this.authenticationRequest;
  }
}

export class DemoOptAuthenticationRequestBuilder {
  private readonly authenticationRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/otp/demo/generate',
    data: {},
  };

  data(data: DemoOptAuthenticationBody) {
    this.authenticationRequest.data = data;
    return this;
  }

  build() {
    return this.authenticationRequest;
  }
}

export class OptGenerateRequestBuilder {
  private readonly authenticationRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/otp/generate',
    data: {},
  };

  data(data: OptGenerateBody) {
    this.authenticationRequest.data = data;
    return this;
  }

  build() {
    return this.authenticationRequest;
  }
}

export class CheckPartnerVitrin {
  private readonly authenticationRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/partners/has-access',
    headers: {},
  };

  token(apiKey: string) {
    this.authenticationRequest.headers['Authorization'] = `Bearer ${apiKey}`;
    return this;
  }

  build() {
    return this.authenticationRequest;
  }
}
